import { render, staticRenderFns } from "./SidebarPanduan.vue?vue&type=template&id=43b34b6c&"
import script from "./SidebarPanduan.vue?vue&type=script&lang=js&"
export * from "./SidebarPanduan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports